import React from "react"

type CronInfoProps = {
  list?: { id: string; cron: string }[]
}

function CronInfo({ list }: CronInfoProps) {
  if (!list) return null

  return (
    <div className="mt-2">
      {list?.length ? (
        <>
          <h5 className="wfp--label">Current fetching mode</h5>
          {list?.map(item => (
            <p style={{ fontSize: "0.875rem" }} key={item?.id}>
              {item?.cron || "Manual"}
            </p>
          ))}
        </>
      ) : (
        <p style={{ fontSize: "0.875rem" }}>There are no scheduled operations</p>
      )}
    </div>
  )
}

export default CronInfo
